<template>
  <div class="saved">
    <div class="header">
      <div class="title-box">
        <span class="title">SAVED PHOTOGRAPHER</span>
      </div>
    </div>
    <transition-group name="list" mode="out-in" tag="div" class="lists">
      <div
        class="item"
        v-for="(item, index) in savedLists"
        v-bind:key="index + 'saved'"
        @click="detail(item.id)"
      >
        <photo-box :data="item"></photo-box>
      </div>
    </transition-group>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types'
import PhotoBox from '@/components/common/PhotoBox'
// import SortBy from '@/components/common/SortBy'
// import Language from '@/components/common/Language'
import { getSaveLists } from '@/api/saved'

export default {
  name: 'saved',
  components: {
    // Language,
    // SortBy,
    PhotoBox
  },
  data() {
    return {
      savedLists: []
    }
  },
  created() {
    this.getSaved()
    console.log('뭐지...')
  },
  methods: {
    getSaved() {
      console.log('get saved')
      getSaveLists(this.$store.getters.userInfo.uid).then(doc => {
        console.log('get saved', doc)
        this.savedLists = doc
      })
    },
    detail(key) {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'request',
        active: true,
        type: 'full',
        propData: {
          serviceId: key
        }
      })
      // this.$store.dispatch(types.SET_MODAL_ALERT_FOOTER, {active: true, text: '입력완료'})
    }
    // loadingCheck(index) {
    //   // console.log(this.serviceLists.length, index + 1)
    //   // if (this.serviceLists.length === index + 1) {
    //   //     setTimeout(() => {
    //   //         this.loadingComplete = true
    //   //     }, 2000)
    //   // }
    // }
  }
}
</script>

<style lang="scss" scoped>
.saved {
  min-height: 600px;
  .header {
    display: flex;
    .title-box {
      margin-bottom: 10px;
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      border-left: solid 1px #e7e7e7;
      border-top: solid 1px #e7e7e7;
      border-right: solid 1px #e7e7e7;
      text-align: center;
      .title {
        line-height: 60px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 1px;
        text-align: center;
        color: #ab08b6;
      }
    }
  }

  .lists {
    width: 1154px;
    z-index: 100;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    /*align-content: space-between;*/
    .item {
      width: 22.5%;
      height: auto;
      margin: 0 20px 68px 0;
    }

    .loading {
      margin: auto;
      position: relative;
      /*border: 1px solid red;*/
      text-align: center;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
